<template>
  <div :class="['div-input', className]">
    <div class="display-only" v-if="isDisplay"></div>
    <div :class="['input-custom', { error: isValidate }]">
      <label v-if="textFloat" :for="name">
        {{ textFloat }}

        <span v-if="isRequired" class="text-danger">*</span>
        <span v-if="selectLang?.name" class="m-0 text-right">
          ({{ selectLang.name }})
        </span>
      </label>

      <input
        :class="['custom-input', inputClass]"
        :type="type == 'password' ? passwordType : type"
        :id="name"
        :placeholder="placeholder"
        :name="name"
        :required="required"
        :value="value"
        :size="size"
        :max="100"
        :oninput="oninput"
        @input="handleInput($event)"
        @change="onDataChange"
        @keyup="$emit('onKeyup', $event)"
        @keydown="handleKeydown($event)"
        @keypress="
          $emit('onKeypress', $event);
          keypressDot($event);
          keypressE($event);
        "
        :disabled="disabled"
        :autocomplete="autocomplete"
        @paste="handlePasteItem($event)"
        :readonly="readonly"
      />

      <div v-if="isShowPassword" class="button-eye">
        <font-awesome-icon
          v-if="passwordType == 'password'"
          @click="handleShowHidePassword"
          :icon="['fas', 'eye-slash']"
        />
        <font-awesome-icon
          v-else
          @click="handleShowHidePassword"
          :icon="['fas', 'eye']"
        />
      </div>
    </div>

    <img :src="img" alt="logo-lang" v-if="img" class="logo-lang" />
    <span v-if="detail" class="text-desc">{{ detail }}</span>

    <div v-if="v && v.$error">
      <span class="text-error" v-if="v.required == false">กรุณากรอกข้อมูล</span>
      <span class="text-error" v-else-if="v.isValidUrl == false"
        >กรุณากรอก URL Link ให้ถูกต้อง (ตัวอย่าง : https://www.example.com)
      </span>
      <span class="text-error" v-else-if="v.eng_number == false"
        >กรุณากรอกเป็นภาษาอังกฤษหรือตัวเลข</span
      >
      <span class="text-error" v-else-if="v.thai_number == false"
        >กรุณากรอกเป็นภาษาไทยหรือตัวเลข</span
      >
      <span class="text-error" v-else-if="v.useVariable == false">
        กรุณากรอกค่าที่สามารถใช้เป็นตัวแปรได้
      </span>
      <span class="text-error" v-else-if="v.hasWhiteSpace == false">
        ไม่สามารถเว้นวรรคได้
      </span>
      <span class="text-error" v-else-if="v.eng_string == false">
        กรุณากรอกเฉพาะตัวอักษรภาษาอังกฤษเท่านั้น
      </span>
      <span class="text-error" v-else-if="v.thai_only == false">
        กรุณากรอกเฉพาะตัวอักษรภาษาไทยเท่านั้น
      </span>
      <span class="text-error" v-else-if="v.Script_checkID == false">
        รูปแบบหมายเลขบัตรประชาชนไม่ถูกต้อง
      </span>
      <span class="text-error" v-else-if="v.minLength == false">
        กรุณากรอกอย่างน้อย {{ v.$params.minLength.min }} ตัวอักษร
      </span>
      <span
        class="text-error"
        v-else-if="v.email == false"
        style="white-space: normal"
      >
        กรุณากรอกอีเมลของคุณ (เช่น email@example.com)
      </span>
      <span class="text-error" v-else-if="v.integer == false">
        กรุณากรอกเฉพาะตัวเลขเท่านั้น
      </span>
      <span class="text-error" v-else-if="v.maxLength == false">
        กรุณากรอกไม่เกิน {{ v.$params.maxLength.max }} ตัวอักษร
      </span>
      <span class="text-error" v-else-if="v.decimal == false">
        กรุณากรอกเฉพาะตัวเลขเท่านั้น
      </span>
      <span class="text-error" v-else-if="v.minValue == false">
        ค่าที่กรอกต้องมากกว่า {{ v.$params.minValue.min }}
      </span>
      <span class="text-error" v-else-if="v.maxValue == false">
        ค่าที่กรอกต้องน้อยกว่าหรือเท่ากับ {{ v.$params.maxValue.max }}
      </span>
      <span class="text-error" v-else-if="v.minValueZero == false">
        ค่าที่กรอกต้องมากกว่า 0
      </span>
      <span class="text-error" v-else-if="v.sameAsPassword == false">
        รหัสผ่านไม่ตรงกัน
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    textFloat: {
      required: true,
      type: String,
    },
    placeholder: {
      required: true,
      type: String,
    },
    type: {
      required: false,
      type: String,
      default: "text",
    },
    required: {
      required: false,
      type: Boolean,
    },
    detail: {
      required: false,
      type: String,
    },
    size: {
      required: false,
      type: String,
    },
    name: {
      required: false,
      type: String,
    },
    value: {
      required: false,
      type: [String, Number],
    },
    isDisplay: {
      required: false,
      type: Boolean,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
    v: {
      required: false,
      type: Object,
    },
    className: {
      required: false,
      type: String,
    },
    img: {
      required: false,
      type: String,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    oninput: {
      required: false,
      type: String,
    },
    useDot: {
      required: false,
      type: Boolean,
      default: true,
    },
    useE: {
      required: false,
      type: Boolean,
      default: true,
    },
    useSub: {
      required: false,
      type: Boolean,
    },
    inputClass: {
      required: false,
      type: String,
    },
    isShowPassword: { required: false },
    autocomplete: { required: false, default: "off" },
    readonly: {
      required: false,
      default: false,
    },
    selectLang: {
      type: Object,
      required: false,
    },
  },
  data() {
    return { passwordType: "password" };
  },
  methods: {
    handleShowHidePassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    handleInput(e) {
      let numberValue =
        this.type == "number"
          ? isNaN(e.target.valueAsNumber)
            ? ""
            : e.target.value[0] == "0" && e.target.value.length > 1
            ? "0" + e.target.valueAsNumber
            : e.target.valueAsNumber
          : e.target.value;
      let value = this.type == "number" ? numberValue : e.target.value;
      this.$emit("input", value);
    },
    onDataChange(event) {
      this.$emit("onDataChange", event.target.value);
    },
    onKeyup(event) {
      this.$emit("onKeyup", event.target.value);
    },
    onKeypress(event) {
      this.$emit("onKeypress", event.target.value);
    },
    handleKeydown(e) {
      if (e.which === 40 || e.which === 38) {
        e.preventDefault();
      }

      this.$emit("onKeydown", e.target.value);
    },
    keypressDot(e) {
      if (e.target.type == "number") {
        if (this.useDot) {
          if (e.charCode === 46 || e.charCode === 45) {
            if (this.useSub && e.charCode == 45) {
              return;
            }
            e.preventDefault();
          }
        }
      }
    },
    handlePasteItem: function (e) {
      if (e.target.type == "number") {
        e.target.value = Number(
          e.clipboardData.getData("text").replace("-", "")
        );
        this.$emit("input", e.target.value);
        return e.preventDefault();
      }
    },
    keypressE(e) {
      if (e.target.type == "number") {
        if (
          e.charCode === 101 ||
          e.charCode === 69 ||
          e.charCode === 45 ||
          e.charCode === 43
        ) {
          if (this.useSub && e.charCode == 45) {
            return;
          }
          e.preventDefault();
        }
      }
    },
  },
};
</script>

<style scoped>
.div-input {
  margin-bottom: 15px;
  position: relative;
  white-space: nowrap;
}
.input-custom {
  padding: 0px;
}
.input-custom > label {
  color: var(--font-main-color);
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: bold;
  width: 100%;
}
.text-right {
  float: right;
  font-weight: 100;
  font-size: 14px;
}

.input-custom > input {
  color: var(--font-main-color);
  border: 1px solid #d8dbe0;
  border-radius: 0.25rem;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
}
.input-custom > input[size="lg"] {
  height: 45px;
}

.input-custom.error > input {
  border-color: red !important;
}
::-webkit-input-placeholder {
  /* Edge */
  color: rgba(22, 39, 74, 0.4);
}
:-ms-input-placeholder {
  /* Internet Explorer */
  color: rgba(22, 39, 74, 0.4);
}
::placeholder {
  color: rgba(22, 39, 74, 0.4);
}
.custom-input {
  display: block;
  /* border: none; */
  width: 100%;
}
.text-desc {
  color: #9b9b9b;
  font-size: 12px;
  font-family: "Kanit-Light";
  margin-top: 3px;
  margin-bottom: 0px;
}
.display-only {
  position: absolute;
  z-index: 5000;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
@media (max-width: 767.98px) {
  /* .div-input {
    margin-top: 0;
  } */
  .input-custom > label {
    font-size: 15px;
  }
}
.button-eye {
  position: absolute;
  right: 10px;
  top: 2.05rem;
  z-index: 6;
}
.button-eye:hover {
  cursor: pointer !important;
}
</style>
